import { forwardRef } from 'react';

import { Button } from './Button.styles';

import type { ButtonProps } from './Button.d';

const ButtonBase = forwardRef(
  (
    { children, onClick, radius, shadow, size, stretch, type, variant, ...props }: ButtonProps,
    ref?: ButtonProps['ref'],
  ) => (
    <Button
      ref={ref}
      data-radius={radius}
      data-shadow={shadow}
      data-size={size}
      data-stretch={stretch}
      data-testid="button"
      data-variant={variant}
      onClick={onClick}
      role="button"
      type={type}
      {...props}
    >
      {children}
    </Button>
  ),
);
ButtonBase.displayName = 'ButtonBase';
export default ButtonBase;
